import {createSlice} from "@reduxjs/toolkit";

const welcomeScreenSlice = createSlice({
    name: "welcomeScreen",
    initialState: {
        isVisible: false,
    },
    reducers:{
        setWelcomeScreen: (state, action) => ({...action.payload}),
        hideWelcomeScreen: (state, action) => ({isVisible: false})
    }
});

export const { setWelcomeScreen, hideWelcomeScreen } = welcomeScreenSlice.actions;

export default welcomeScreenSlice.reducer;
